// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cbbcd9d1","713":"fcded7be"}[chunkId] + ".chunk.js";
};